import React, { useState, useEffect, useCallback } from "react";
import "./AdminDashboard.css";
import "chartjs-adapter-date-fns";
import AdminUserVisualisation from "./AdminUserVisualisation/AdminUserVisualisation";
import AdminUserPersonalityVisualisation from "./AdminUserVisualisation/AdminUserPersonalityVisualisation";
import AdminAllUserVisualisation from "./AdminAllUserVisualisation/AdminAllUserVisualisation";
import AdminAllUserPersonalityVisualisation from "./AdminAllUserVisualisation/AdminAllUserPersonalityVisualisation";
import AllQuizQuestionsTable from "./AllQuizQuestionsTable/AllQuizQuestionsTable";
import AllPersonalityQuizQuestionsTable from "./AllQuizQuestionsTable/AllPersonalityQuizQuestionsTable";
import UserLatestScoresTable from "./UserLatestScoresTable/UserLatestScoresTable";
import LatestPersonalityScoresTable from "./UserLatestScoresTable/LatestPersonalityScoresTable";
import RecommendationsTable from "./RecommendationsTable/RecommendationsTable";
import { useNavigate } from "react-router-dom";

function AdminDashboard({ userData }) {
  const [allUserData, setAllUserData] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [error, setError] = useState(null);
  const [view, setView] = useState("empathy");
  const navigate = useNavigate();

  const fetchQuizQuestions = useCallback(() => {
    fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/quizQuestions`,
      {
        method: "GET",
        credentials: "include",
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          console.error(data.error);
        } else {
          setQuestions(data.quiz_questions);
        }
      })
      .catch((error) => {
        console.error("Error fetching quiz questions:", error);
      });
  }, []);

  useEffect(() => {
    fetchQuizQuestions();
  }, [fetchQuizQuestions]);

  // Fetch user data from the backend
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/data`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          console.error(data.error);
          setError(data.error);
        } else {
          console.log("All user data:", data);
          setAllUserData(data);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setError("Error fetching data");
      });
  }, [userData]);

  // handle logout
  const handleLogout = () => {
    fetch(`${process.env.REACT_APP_BACKEND_FLASK_API_URL}/logout`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data.message);
        navigate(`/`);
      })
      .catch((error) => console.error("Error logging out:", error));
  };

  // handle score history
  const handleHistory = () => {
    navigate(`/admin/score-history`);
  };

  const handleAllUserScores = () => {
    navigate(`/admin/all-user-scores`);
  };

  const handleUserManagement = () => {
    navigate(`/admin/user-management`);
  };

  if (!userData) {
    return <div>Loading...</div>; // or null
  }

  if (error) {
    return <div>{error}</div>;
  }

  let noScores = false;
  if (userData.scores.length === 0) {
    noScores = true;
  }

  return (
    <div className="admin-dashboard">
      <header className="dash-header">
        <button
          onClick={() => {
            if (noScores) {
              navigate(`/consent`, { state: { from: "dashboard" } });
            } else {
              navigate(`/quiz-nav`);
            }
          }}
        >
          Quiz
        </button>
        <button onClick={handleUserManagement}>User Management</button>{" "}
        <button onClick={handleHistory}>History</button>{" "}
        {/*Score History BUTTON */}
        <button onClick={handleAllUserScores}>All User Scores</button>{" "}
        <button onClick={handleLogout}>Log Out</button>
      </header>
      <div className="admin-dashboard-content">
        <h3>{userData.username}</h3>
        <p>{userData.email}</p>
      </div>

      {/* Switch between Empathy and Personality */}
      <div className="view-switch">
        <label>
          <input
            type="radio"
            name="quizView"
            value="empathy"
            checked={view === "empathy"}
            onChange={() => setView("empathy")}
          />
          Empathy
        </label>
        <label>
          <input
            type="radio"
            name="quizView"
            value="personality"
            checked={view === "personality"}
            onChange={() => setView("personality")}
          />
          Personality
        </label>
      </div>

      <div className="visualisations">
        <div className="per-user">
          {allUserData ? (
            view === "empathy" ? (
              <AdminUserVisualisation allUserData={allUserData} />
            ) : (
              <AdminUserPersonalityVisualisation allUserData={allUserData} />
            )
          ) : (
            <div>Loading...</div>
          )}
        </div>
        <div className="all-users">
          {allUserData ? (
            view === "empathy" ? (
              <AdminAllUserVisualisation allUserData={allUserData} />
            ) : (
              <AdminAllUserPersonalityVisualisation allUserData={allUserData} />
            )
          ) : (
            <div>Loading...</div>
          )}
        </div>
      </div>

      {view === "empathy" ? (
        <>
          <UserLatestScoresTable userData={userData} />
          <AllQuizQuestionsTable
            fetchQuizQuestions={fetchQuizQuestions}
            questions={questions}
            userData={userData}
          />
          <RecommendationsTable fetchQuizQuestions={fetchQuizQuestions} />
        </>
      ) : (
        <>
          <LatestPersonalityScoresTable />
          <AllPersonalityQuizQuestionsTable />
        </>
      )}
    </div>
  );
}

export default AdminDashboard;
